module.exports = __webpack_public_path__ + "static/img/favicon.f4c963f6.png";